export default function (value) {
    if (value === null) {
        return value;
    }
    else if (value === "mr"){
        return "Herr";
    }
    else if (value === "mrs"){
        return "Frau";
    }
}
